import {
	Dashboard,
	Accounting,
	Configuration,
	Support,
	Institution,
	InstitutionsGroupIcon,
	PendingLoansIcon,
	SavingsIcon,
	SavingsProductIcon,
	TransactionsIcon,
	FtdIcon,
	FtdAmountIcon,
	GroupsIcon,
	GroupSavingIcon,
	AvatarProfileIcon,
	AvatarSettingsIcon,
	AvatarHelpIcon,
	LogoutIcon,
	UserManagementIcon,
} from "../assets";

export const sideNavigationItems = [
	{
		name: "Dashboard",
		icon: <Dashboard />,
		url: "/dashboard",
	},
	{
		name: "Institutions",
		icon: <Institution />,
		items: [
			{
				name: "Create Institution",
				url: "/institution/createinstitution",
			},
			{
				name: "List of Institutions",
				url: "/institution/listofinstitutions",
			},
		],
	},
	{
		name: "Accounting",
		icon: <Accounting />,
		items: [
			{
				name: "Check SMS Balance",
				url: "/accounting/checksmsbalance",
			},
			{
				name: "SMS Top Up",
				url: "/accounting/smstopup",
			},
		],
	},
	{
		name: "User Management",
		icon: <UserManagementIcon />,
		items: [
			{
				name: "System Users",
				url: "/usermanagement/systemusers",
			},
			{
				name: "User Role",
				url: "/usermanagement/userrole",
			},
			{
				name: "Access Control",
				url: "/usermanagement/accesscontrol",
			},
		],
	},
	{
		name: "Configuration",
		icon: <Configuration />,
		items: [
			{
				name: "Setup SMS Alert",
				url: "/configuration/smsalert",
			},
			{
				name: "Setup Currency",
				url: "/configuration/currency",
			},
		],
	},
	{
		name: "Migration",
		icon: <Dashboard />,
		url: "/migration",
	},
	{
		name: "Support Tickets",
		icon: <Support />,
		url: "",
	},
];

export const avatarOptions = [
	{
		title: "Edit profile",
		icon: <AvatarProfileIcon width={16} height={16} />,
		url: "/profile",
	},
	{
		title: "Settings",
		icon: <AvatarSettingsIcon width={16} height={16} />,
		url: "/settings",
	},
	{
		title: "Help",
		icon: <AvatarHelpIcon width={16} height={16} />,
		url: "/help",
	},
	{
		title: "Log out",
		icon: <LogoutIcon width={16} height={16} />,
		url: "/logout",
	},
];

export const dashboardCards = [
	{
		name: "NO. OF INSTITUTIONS",
		icon: <InstitutionsGroupIcon />,
		bg: "#68C302",
		no: "4",
	},
	{
		name: "PENDING LOANS",
		icon: <PendingLoansIcon />,
		bg: "#F4512E",
		no: "0",
	},
	{
		name: "TOTAL SAVINGS",
		icon: <SavingsIcon />,
		bg: "#791377",
		no: "0.00",
	},
	{
		name: "NO. OF SAVINGS PRODUCT",
		icon: <SavingsProductIcon />,
		bg: "#18B0A1",
		no: "0",
	},
	{
		name: "ACTIVE CUSTOMERS",
		icon: <InstitutionsGroupIcon />,
		bg: "#68C302",
		no: "0",
	},
	{
		name: "NO. OF SAVINGS ACCT",
		icon: <SavingsIcon />,
		bg: "#18B0A1",
		no: "0",
	},
	{
		name: "DISBURSED LOAN AMOUNT",
		icon: <PendingLoansIcon />,
		bg: "#F4512E",
		no: "0.00",
	},
	{
		name: "NO. OF TRANSACTIONS",
		icon: <TransactionsIcon />,
		bg: "#791377",
		no: "0",
	},
	{
		name: "DEPOSIT TRANSACTIONS",
		icon: <TransactionsIcon />,
		bg: "#F4512E",
		no: "0",
	},
	{
		name: "NO. OF FTD ACCTS",
		icon: <FtdIcon />,
		bg: "#68C302",
		no: "0",
	},
	{
		name: "FTD AMT",
		icon: <FtdAmountIcon />,
		bg: "#F4512E",
		no: "0.00",
	},
	{
		name: "NO. OF GROUPS",
		icon: <GroupsIcon />,
		bg: "#791377",
		no: "0",
	},
	{
		name: "GROUP SAVINGS",
		icon: <GroupSavingIcon />,
		bg: "#18B0A1",
		no: "0.00",
	},
];
